<!-- <jni-orders-listing
  *ngIf="saleOrderListNonAdminStatus"
  class="order-listing-paginated-page"
  [customerAccountNumber]="customerAccountNumber"
  [isAdditionalFilters]="isAdditionalFilters ? '1' : ''"
  [orderType]="orderType"></jni-orders-listing>
<jni-order-listing-paginated
  class="order-listing-paginated-page"
  *ngIf="saleOrderListAdminStatus"
  [customerAccountNumber]="customerAccountNumber"
  [isAdditionalFilters]="isAdditionalFilters"
  [orderType]="orderType"
  [isFromSupportAllocation]="isFromSupportAllocation"
  (openOrderListingModal)="closeModal()"></jni-order-listing-paginated> -->

<jni-order-listing-paginated
  class="order-listing-paginated-page"
  [customerAccountNumber]="customerAccountNumber"
  [isAdditionalFilters]="isAdditionalFilters"
  [orderType]="orderType"
  [isFromSupportAllocation]="isFromSupportAllocation"
  (openOrderListingModal)="closeModal()"></jni-order-listing-paginated>
